import { Availability } from '../AvailabilityView';
import { Box, Container } from '@chakra-ui/react';
import { PickerEmptyState, PickerField, PickerRow } from './pickerUi';
import { useEffect, useState } from 'react';

export const PickerKG = (props: any) => {
	const [isValidating] = useState(false);
	const [subject, setSubject] = useState('');
	const [school, setSchool] = useState('');
	const [grade, setGrade] = useState('');
	const [level, setLevel] = useState('');
	const [isMobileCollapsed, setIsMobileCollapsed] = useState(false);
	const isFilled = subject === 'mat' ? Boolean(subject && school && grade) : Boolean(subject && level);

	useEffect(() => {
		if (isFilled) setIsMobileCollapsed(true);
	}, [isFilled]);

	const handleSubjectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const nextSubject = event.currentTarget.value;
		setSubject(nextSubject);
		setSchool('');
		setGrade('');
		setLevel('');
	};

	const handleSchoolChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		setSchool(event.currentTarget.value);
		setGrade('');
	};

	const getCode = () => {
		let bucket;
		if (school === 'SP') {
			if (grade === '4' || grade === '5') bucket = 'SP1';
			if (grade === '6' || grade === '7') bucket = 'SP2';
		}
		if (school === 'TECH') {
			if (grade === '1' || grade === '2') bucket = 'LO1';
			if (grade === '3' || grade === '4') bucket = 'LO2';
		}
		if (school === 'LIC') {
			if (grade === '1' || grade === '2') bucket = 'LO1';
			if (grade === '3') bucket = 'LO2';
		}
		const suffix = subject === 'ang' ? level : bucket;
		return `${subject}_grupa_${suffix}`;
	};

	const renderLevelForSubject = (school: any) => {
		switch (subject) {
			case 'ang':
				return [
					<option value="B1" key="B1">
						B1
					</option>,
					<option value="B2" key="B2">
						B2
					</option>,
				];
			default:
				return [];
		}
	};

	const renderGradesForSchool = (school: any) => {
		let start = 0;
		let limit = 0;
		switch (school) {
			case '':
				return [];
			case 'SP':
				start = 3;
				limit = 7;
				break;
			case 'LIC':
				limit = 3;
				break;
			case 'TECH':
				limit = 4;
				break;
		}
		return [...Array(limit - start)].map((_, idx) => (
			<option value={String(start + idx + 1)} key={idx}>
				{start + idx + 1}
			</option>
		));
	};

	return (
        <Box pb={2}>
            <PickerRow
                collapsible={isFilled}
                isCollapsed={isMobileCollapsed}
                onToggleCollapse={() => setIsMobileCollapsed((value) => !value)}
            >
                <PickerField
                    label="Przedmiot"
                    value={subject}
                    invalid={!subject && isValidating}
                    placeholder="- przedmiot -"
                    onChange={handleSubjectChange}
                >
                    <option value="mat">matematyka</option>
                    <option value="ang">j. angielski</option>
                </PickerField>
                <PickerField
                    label="Typ szkoły"
                    value={school}
                    invalid={!school && isValidating}
                    placeholder="- typ szkoły -"
                    onChange={handleSchoolChange}
                    disabled={subject === 'ang'}
                >
                    {subject === 'ang' ? null : (
                        <>
                            <option value="SP">szkoła podstawowa</option>
                            <option value="LIC">liceum</option>
                            <option value="TECH">technikum</option>
                        </>
                    )}
                </PickerField>
                <PickerField
                    label="Klasa"
                    value={grade}
                    invalid={!grade && isValidating}
                    placeholder="- klasa -"
                    onChange={(event) => setGrade(event.currentTarget.value)}
                    disabled={subject === 'ang'}
                >
                    {subject !== 'ang' && school && renderGradesForSchool(school)}
                </PickerField>
                <PickerField
                    label="Poziom"
                    value={level}
                    invalid={!level && isValidating && subject !== 'mat'}
                    placeholder="- poziom -"
                    onChange={(event) => setLevel(event.currentTarget.value)}
                    disabled={subject === 'mat'}
                >
                    {renderLevelForSubject(subject)}
                </PickerField>
            </PickerRow>
            {isFilled ? (
				<Availability
					code={getCode()}
					type="KG"
					onPick={(lesson: any) => {
						props.onPick({
							...lesson,
							subjectCode: subject,
							kind: 'Korepetycje grupowe',
							student: {
								school: subject !== 'ang' ? '' : school,
								grade: subject !== 'ang' ? '' : grade,
								level: subject === 'mat' ? '' : level,
							},
						});
					}}
				/>
			) : (
				<Container centerContent>
					<PickerEmptyState />
				</Container>
			)}
        </Box>
    );
};
